











































































































interface NewSz { id: number; name: string; value: string; }
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ElSelect } from "element-ui/types/select";
 
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class NewAddRow extends Vue {
    @Prop({ type: Boolean })
    notAllow!: boolean;

    @Prop({ type: String })
    endMonth!: string;

    @Prop({ type: Array })
    sztypes!: NewSz[];

    @Prop({ type: Object })
    accounters!: any;

    @Prop({ type: Array })
    list!: Journal.Journal;

    @Prop({ type: Object })
    options!: any;

    @Prop({ type: Array })
    banks!: { key: string; value: boolean; }[];

    accountList: any = this.accounters;
    //新增可用的
    newDate: Date | string = "";
    newZy: string = "";
    newSz: NewSz = this.sztypes[0];
    newAccount: string = "";
    newIncome: string = "";
    newOut: string = "";
    newBank: string = "";

    @Watch("accounters", { deep: true })
    accountersChange(val: any) {
        this.accountList = val;
    }

    mounted() {
        this.newDate = new Date(this.endMonth.substring(0, 4) + "-" + this.endMonth.substring(4))
        this.newSz = this.sztypes[0];
    }

    @Watch("endMonth")
    monthChange(val: string) {
        this.endMonth = val;

    }
    // 监听
    @Watch("list")
    listChange(val: Journal.Journal[]) {
        if (val.length === 0 && this.endMonth) this.newDate = new Date(this.endMonth.substring(0, 4) + "-" + this.endMonth.substring(4));
        else this.newDate = val[val.length - 1].journalDate;
    }

    // 清除新增内容
    clearData() {
        this.newZy = this.newAccount = this.newIncome = this.newOut = this.newBank = "";
        if (this.sztypes) this.newSz = this.sztypes[0];
    }
    // 失去焦点行
    blurRow() {
        this.$nextTick(() => {
            if ((<HTMLElement>document.activeElement).getAttribute("name") != "newTr") {
                this.$emit("blur")
            }
        })
    }
    // 选中收支类型
    changeSz() {
        let select = <ElSelect>this.$refs.accountSelect;
        select.focus();
    }
    // 焦点离开对方户名
    blurAccount(e: any, id: number) {
        let tmp = e.target.value;
        this.$nextTick(() => {
            if (this.accountList["a" + id].indexOf(e.target.value) === -1) this.newAccount = tmp;
            else this.newAccount = e.target.value;
        })
    }
    // 监听收入支出
    @Watch("newIncome")
    changeIncome(val: string) {
        this.newOut = "";
    }
    @Watch("newOut")
    changeOut() {
        this.newIncome = ""
    }

    pressEnter(e: KeyboardEvent, numInput: boolean, isLast?: boolean, isAccount?: boolean) {
        this.$utils.arrowPress(e, false);
        if (isAccount) {
            let select = (<ElSelect>this.$refs.accountSelect);
            // @ts-ignore
            select.doDestroy();
        }
        if (isLast && (e.keyCode === 13)) this.$emit("blur");
    }

    focusSummary() {
        (<ElSelect>this.$refs.newZy).focus();
    }
}
